import React from "react";

// EXTRAS
import { translateOrderType } from "../../extras";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";
import { phoneMask } from "../../utils/formatters";

export default function OrderTicketDeliveryInfos({
  channel,
  delivery_obs,
  address,
  order_contact,
  delivery_pickup_code,
  order_type,
}) {
  const {
    street,
    house_number,
    address_complement,
    address_reference,
    city,
    uf,
    cep,
    neighborhood,
  } = address;

  return (
    <Box>
      <TypographyBoldOnPrint
        variant="body2"
        align="center"
        fontWeight="bold"
        color={grey["900"]}
      >
        DADOS DO PEDIDO
      </TypographyBoldOnPrint>
      {order_type === "DELIVERY" && delivery_pickup_code && (
        <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
          Código iFood: {delivery_pickup_code}
        </TypographyBoldOnPrint>
      )}
      <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
        Contato:{" "}
        {channel === "IFOOD"
          ? order_contact
          : phoneMask(order_contact) || "Não Definido"}
      </TypographyBoldOnPrint>
      {order_type === "DELIVERY" ? (
        <>
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            Rua: {street}, {house_number}
          </TypographyBoldOnPrint>
          {address_complement && (
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              Comp: {address_complement}
            </TypographyBoldOnPrint>
          )}
          {address_reference && (
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              Ref: {address_reference}
            </TypographyBoldOnPrint>
          )}
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            Cidade: {city} - {uf}
          </TypographyBoldOnPrint>
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            CEP: {cep}
          </TypographyBoldOnPrint>
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            Bairro: {neighborhood}
          </TypographyBoldOnPrint>
          {delivery_obs && (
            <TypographyBoldOnPrint
              variant="body2"
              align="center"
              color={grey["900"]}
              gutterBottom
            >
              {delivery_obs}
            </TypographyBoldOnPrint>
          )}
        </>
      ) : (
        <TypographyBoldOnPrint variant="body1" color={grey["900"]} gutterBottom>
          {translateOrderType(order_type)}
        </TypographyBoldOnPrint>
      )}
      <Divider sx={{ mb: 1 }} />
    </Box>
  );
}
